import cloneDeep from 'lodash/fp/cloneDeep'
import {
  FETCHED_RESET_TOKEN_VERIFICATION,
  FETCHING_RESET_TOKEN_VERIFICATION,
  ADMINISTRATION_UPDATE_PASSWORD_SUBMITTING,
  ADMINISTRATION_UPDATE_PASSWORD_SUBMITTED,
  ADMINISTRATION_UPDATE_PASSWORD_SET_NEW_PASSWORD,
  ADMINISTRATION_UPDATE_PASSWORD_SET_CONFIRMED_PASSWORD
} from './resetPasswordContainerActions.js'
import { validiatePasswordField } from '../../common/forms/validationFunctions'

const initialState = {
  loading: true,
  resetToken: null,
  administratorName: '',
  submitting: false,
  submitted: false,
  newPassword: '',
  newPasswordEdited: false,
  confirmedPassword: '',
  confirmedPasswordEdited: false,
  isInvalid: {
    formIsValid: false,
    newPassword: {
      isInvalid: false,
      message: null
    },
    confirmedPassword: {
      isInvalid: false,
      message: null
    }
  }
}

export default function (state = initialState, action) {
  var newState = cloneDeep(state)
  switch (action.type) {
    case FETCHED_RESET_TOKEN_VERIFICATION:
      newState.loading = false
      return newState
    case FETCHING_RESET_TOKEN_VERIFICATION:
      newState.loading = true
      return newState
    case ADMINISTRATION_UPDATE_PASSWORD_SET_NEW_PASSWORD:
      newState.newPassword = action.newPassword
      newState.newPasswordEdited = true
      newState.isInvalid.newPassword = validiatePasswordField(action.newPassword)
      newState.isInvalid.confirmedPassword = validiatePasswordField(state.confirmedPassword, action.newPassword)
      newState.isInvalid.formIsValid = formIsValid(newState)
      return newState
    case ADMINISTRATION_UPDATE_PASSWORD_SET_CONFIRMED_PASSWORD:
      newState.confirmedPassword = action.confirmedPassword
      newState.confirmedPasswordEdited = true
      newState.isInvalid.confirmedPassword = validiatePasswordField(action.confirmedPassword, state.newPassword)
      newState.isInvalid.formIsValid = formIsValid(newState)
      return newState
    case ADMINISTRATION_UPDATE_PASSWORD_SUBMITTED:
      newState.submitting = false
      newState.submitted = true
      return newState
    case ADMINISTRATION_UPDATE_PASSWORD_SUBMITTING:
      newState.submitting = true
      return newState
  }
  return state
}

function formIsValid (state) {
  return state.newPassword === state.confirmedPassword &&
      state.newPasswordEdited &&
      state.confirmedPasswordEdited &&
      state.isInvalid.newPassword.isInvalid !== true &&
      state.isInvalid.confirmedPassword.isInvalid !== true
}
